import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    {
        Name: "Abhay Kumar",
        Position: "Ph.D Scholar",
        Batch: "Jan 2024",
        AreasOfResearch: "Plasma-based wastewater treatment",
        GuideName: "Dr. Shihabudheen M. Maliyekkal",
        GuideLink: "/dr-shihabudheen-m-maliyekkal",
        CoGuideName: "Dr. Reetesh Kumar Gangwar",
        CoGuideLink: "/dr-reetesh-kumar-gangwar",
        Email: "ce24d001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Abhay_Kumar_PhD.png",
    },

    {
        Name: "Arunkumar S",
        Position: "Ph.D Scholar",
        Batch: "Jan 2024",
        AreasOfResearch: "Structural behaviour of 3D printed concrete",
        GuideName: "Dr. Bijily Balakrishnan",
        GuideLink: "/dr-bijily-balakrishnan",
        CoGuideName: "Dr. A.V.Rahul",
        CoGuideLink: "/dr-a-v-rahul",
        Email: "ce24d002@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Arunkumar_S_PhD.png",
    },
    
    {
        Name: "MK Raeesh",
        Position: "Ph.D Scholar",
        Batch: "Jan 2024",
        AreasOfResearch: "Sustainable Management of Groundwater Resources",
        GuideName: "Dr. Prasanna Venkatesh Sampath",
        GuideLink: "/dr-prasanna-venkatesh",
        Email: "ce24d003@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/MK_Raeesh_PhD.png"
    },

    {
        Name: "Pandiri Nithish Reddy",
        Position: "Ph.D Scholar",
        Batch: "Jan 2024",
        AreasOfResearch: "Structural Fire Engineering",
        GuideName: "Dr. Jashnav Pancheti",
        GuideLink: "/dr-jashnav-pancheti",
        Email: "ce24d004@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Pandiri_Nithish_Reddy_PhD.png"
    },
    {
        Name: "Vishal",
        Position: "Ph.D Scholar",
        Batch: "Jan 2024",
        AreasOfResearch: "Air Pollution modelling and management",
        GuideName: "Prof. Suresh Jain",
        GuideLink: "/dr-suresh-jain",
        Email: "ce24d005@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Vishal_PhD_2024.png"
    },
    {
        Name: "Badugu Lakshmi Prasanna",
        Position: "Ph.D Scholar",
        Batch: "July 2023",
        AreasOfResearch: "Hydromechanical behaviour of Plastic concrete Diaphragm wall under static and seismic loads.",
        GuideName: "Dr. B. Janaki Ramaiah",
        GuideLink: "/dr-b-janaki-ramaiah",
        Email: "ce23d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Badugu_Lakshmi_Prasanna_PhD.png"
    },
    {
        Name: "Manish Bhargav Bommareddy",
        Position: "Ph.D Scholar",
        Batch: "July 2023",
        AreasOfResearch: "Life Cycle Assessment",
        GuideName: "Prof. Suresh Jain",
        GuideLink: "/dr-suresh-jain",
        Email: "ce23d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Manish_Bhargav_Bommareddy_PhD.png"
    },
    {
        Name: "Gagan G S",
        Position: "Ph.D Scholar",
        Batch: "July 2023",
        AreasOfResearch: "3D Printing Concrete",
        GuideName: "Dr. A V Rahul",
        GuideLink: "/dr-a-v-rahul",
        Email: "ce23d503@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Gagan_G_S_PhD.png"
    },

    {
        Name: "Naveen Kumar V",
        Position: "Ph.D Scholar",
        Batch: "July 2023",
        AreasOfResearch: "Corrosion of Steel in Cementitious Systems",
        GuideName: "Dr. Prasanna Kumar Behera",
        GuideLink: "/dr-prasanna-kumar-behera",
        Email: "ce23d504@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Naveen_Kumar_ V_PhD.png"
    },
    

    {
        Name: "Puttamreddy Sivasai",
        Position: "Ph.D Scholar",
        Batch: "July 2023",
        AreasOfResearch: "Wastewater treatment",
        GuideName: "Dr. Narasamma Nippatlapalli",
        GuideLink: "/dr-narasamma-nippatlapalli",
        Email: "ce23d505@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Puttamreddy_Sivasai_PhD.png"
    },
    {
        Name: "Sheikh Hazim",
        Position: "Ph.D Scholar",
        Batch: "Jan 2023",
        AreasOfResearch: "Pavement Geotechnics",
        GuideName: "Prof. B. Krishna Prapoorna",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. B. Janaki Ramaiah",
        CoGuideLink: "/dr-b-janaki-ramaiah",
        Email: "ce23d001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Sheikh Hazim.png",
    },
    {
        Name: "Shouvik Bhattacharjee",
        Position: "Ph.D Scholar",
        Batch: "Jan 2023",
        AreasOfResearch: "Synthetic Aperture Radar Interferometry",
        GuideName: "Dr. Avadh Bihari Narayan",
        GuideLink: "/dr-avadh-bihari-narayan",
        Email: "ce23d002@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Shouvik Bhattacharjee.png",
    },
    {
        Name: "Suhas T R",
        Position: "Ph.D Scholar",
        Batch: "Jan 2023",
        AreasOfResearch: "Pavement Design & Modeling",
        GuideName: "Prof. B. Krishna Prapoorna",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. B. Radhika",
        CoGuideLink: "#",
        Email: "ce23d003@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Suhas T R.png",
    },
    {
        Name: "R Urmila Raghava Panikkar",
        Position: "Ph.D Scholar",
        Batch: "Jan 2023",
        AreasOfResearch: "Watershed Management",
        GuideName: "Dr. Roshan Srivastav",
        GuideLink: "/dr-roshan-srivastav",
        Email: "ce23d004@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/R Urmila.png",
    },
    {
        Name: "Namitha S",
        Position: "Ph.D Scholar",
        Batch: "Jan 2023",
        AreasOfResearch: "Life Cycle Assessment Of Roadway Infrastructure",
        GuideName: "Prof. B. Krishna Prapoorna",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. Chaitanya Bhat",
        CoGuideLink: "#",
        Email: "ce23d005@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Namitha S.png",
    },
    {
        Name: "Divya S Kurup",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Early age shrinkage in Fresh Paste, Concrete Durability",
        GuideName: "Dr. A V Rahul",
        GuideLink: "/dr-a-v-rahul",
        Email: "ce22d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Divya S Kurup.jpg",
    },
    {
        Name: "Harmandeep Kaur",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Modified Asphalt Rubber",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        Email: "ce22d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Harmandeep.jpg",
    },
    {
        Name: "Jadala Srinivas",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Field Implementation of Pervious Concrete",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        Email: "ce22d503@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Jadala Srinivas.jpg",
    },

    {
        Name: "Kondapalli Leela Aparna Devi",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Design parameters for Ultra High Performance Concrete (UHPC) Bridge",
        GuideName: "Dr. Bijily Balakrishnan",
        GuideLink: "/dr-bijily-balakrishnan",
        Email: "ce22d504@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Aparna Devi.jpg",
    },
    {
        Name: "Neetu G Kumar",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Pavement materials",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. Sriram Sundar",
        CoGuideLink: "/dr-sriram-sundar",
        Email: "ce22d505@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Neetu.jpg"
    },
    {
        Name: "Sneha Rajan",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Life Cycle Assessment, Sustainable Pavements",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        Email: "ce22d506@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Sneha.jpg"
    },
    {
        Name: "Spoorthy B M",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Composite Pavement Materials",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. P. Venkataraman",
        CoGuideLink: "/dr-p-venkataraman",
        Email: "ce22d507@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Spoorthy.jpg"
    },

    {
        Name: "Susarla Naga Sai Mounika",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Remote sensing and GIS, SAR Interferometry",
        GuideName: "Dr. Avadh Bihari Narayan",
        GuideLink: "/dr-avadh-bihari-narayan",
        Email: "ce22d508@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Sai Mounika.jpg"
    },
    {
        Name: "Vijaya Raj S",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Use of waste derived materials in Geotechnical Applications",
        GuideName: "Dr. B. Janaki Ramaiah",
        GuideLink: "/dr-b-janaki-ramaiah",
        Email: "ce22d509@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Vijaya Raj.jpg"
    },
    {
        Name: "Mattaparthi Sri Gangadhar",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Innovative Pavement Materials and Warm Mix Asphalt Technology",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. Sriram Sundar",
        CoGuideLink: "/dr-sriram-sundar",
        Email: "ce22d510@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Sri Gangadhar.jpg"
    },

    {
        Name: "Surya M",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Pavement Technology; Tire / Pavement Interaction and Dynamics",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. Sriram Sundar",
        CoGuideLink: "/dr-sriram-sundar",
        Email: "ce22d511@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Surya M.jpg"
    },

    {
        Name: "Tanay Sanjay Gham",
        Position: "MS (Research) Scholar",
        Batch: "July 2022",
        AreasOfResearch: "Development of Specification for Field Implementation of Pervious Concrete",
        GuideName: "Prof. Krishna Prapoorna B",
        GuideLink: "/dr-b-krishna-prapoorna",
        Email: "ce22501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Sanjay.jpg"
    },

    {
        Name: "Malladi Bhanuprakash",
        Position: "Ph.D (Research) Scholar",
        Batch: "Jan 2022",
        AreasOfResearch: "Steel rebar corrosion in concrete",
        GuideName: "Dr. Prasanna Kumar Behera",
        GuideLink: "/dr-prasanna-kumar-behera",
        Email: "ce22d003@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Bhanuprakash.jpg"
    }

    , {
        Name: "Tadavarthi Pushparaj Gandhi",
        Position: "Ph.D (Research) Scholar",
        Batch: "Jan 2022",
        AreasOfResearch: "Food treatment",
        GuideName: "Dr. Shihabudheen M. Maliyekkal",
        GuideLink: "/dr-shihabudheen-m-maliyekkal",
        CoGuideName: "Dr. Reetesh Kumar Gangwar",
        CoGuideLink: "/dr-reetesh-kumar-gangwar",
        Email: "ce22d005@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Pushparaj.jpg"
    },

    {
        Name: "Tongire Kalpesh Rajendra",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2021",
        AreasOfResearch: "Capacitive deionization",
        GuideName: "Dr. Shihabudheen M. Maliyekkal",
        GuideLink: "/dr-shihabudheen-m-maliyekkal",
        Email: "ce21d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Kalpesh.jpg"
    },

    {
        Name: "Vajitha G",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2021",
        AreasOfResearch: "Capacitive deionization",
        GuideName: "Dr. Shihabudheen M. Maliyekkal",
        GuideLink: "/dr-shihabudheen-m-maliyekkal",
        Email: "ce21d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Vajitha.jpg"
    },

    {
        Name: "Maturi Sai Venkata Naga Jyothi",
        Position: "Ph.D (Research) Scholar",
        Batch: "July 2021",
        AreasOfResearch: "Development of point of use water treatment system",
        GuideName: "Dr. Shihabudheen M. Maliyekkal",
        GuideLink: "/dr-shihabudheen-m-maliyekkal",
        CoGuideName: "Dr. B. Janaki Ramaiah",
        CoGuideLink: "/dr-b-janaki-ramaiah",
        Email: "ce21d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Maturi.jpg"
    },
    {
        Name: "Asmita Ashok Naitam",
        Position: "M.S (Research) Scholar",
        Batch: "July 2021",
        AreasOfResearch: "Statistical Downscaling",
        GuideName: "Dr. Roshan Srivastav",
        GuideLink: "/dr-roshan-srivastav",
        Email: "ce21s001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Asmita.jpg"
    },
    {
        Name: "Gubbala Chaitanya",
        Position: "Ph.D Scholar",
        Batch: "Jan 2021",
        AreasOfResearch: "Thermophysical properties of pavements",
        GuideName: "Prof. B. Krishna Prapoorna",
        GuideLink: "/dr-b-krishna-prapoorna",
        Email: "ce21d001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/chaitanya.jpg"
    },
    {
        Name: "Manuj Sharma",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasOfResearch: "Air Pollution and Health Risk Analysis",
        GuideName: "Prof. Suresh Jain",
        GuideLink: "/dr-suresh-jain",
        Email: "ce20d503@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/manuj.jpg"
    },
    {
        Name: "Kiruthika P",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasOfResearch: "Geotechnical Earthquake Engineering",
        GuideName: "Dr. A. Murali Krishna",
        GuideLink: "/dr-a-murali-krishna",
        CoGuideName: "Prof. Subhadeep Banerjee (IIT Madras)",
        Email: "ce20d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Kiruthika.jpg"
    },
    {
        Name: "Abhilash M",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasOfResearch: "Seismic Rehabilitation & Retrofitting of Structures",
        GuideName: "Dr. Romanbabu Oinam",
        GuideLink: "/dr-romanbabu-m-oinam",
        Email: "ce20d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Abhilash.jpg"
    },
    {
        Name: "Shivachethan V",
        Position: "Ph.D Scholar",
        Batch: "Jan 2020",
        AreasOfResearch: "Lateral movement of vehicles on urban roads in disordered traffic",
        GuideName: "Dr. A. Gowri",
        GuideLink: "/dr-a-gowri",
        Email: "ce20d002@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/Shivachethan.jpg"
    },
    {
        Name: "Abins Aziz",
        Position: "Ph.D Scholar",
        Batch: "Jan 2020",
        AreasOfResearch: "Application of nanomaterials in cement composites",
        GuideName: "Dr. Bijily Balakrishnan",
        GuideLink: "/dr-bijily-balakrishnan",
        CoGuideName: "Dr. Shihabudheen M. Maliyekkal",
        CoGuideLink: "/dr-shihabudheen-m-maliyekkal",
        Email: "ce20d001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/abins.jpg"
    },
    {
        Name: "Srilakshmi Lolla",
        Position: "M.S (Research) Scholar",
        Batch: "July 2019",
        AreasOfResearch: "",
        GuideName: "Dr. Romanbabu Oinam",
        GuideLink: "/dr-romanbabu-m-oinam",
        Email: "ce19s501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/srilakshmi.jpg"
    },
    {
        Name: "Chitti Satya Sundara Uday Srikanth",
        Position: "Ph.D Scholar",
        Batch: "July 2019",
        AreasOfResearch: "Dynamic properties of unsaturated soils",
        GuideName: "Dr. B. Janaki Ramaiah",
        GuideLink: "/dr-b-janaki-ramaiah",
        CoGuideName: "Dr. A. Murali Krishna",
        CoGuideLink: "/dr-a-murali-krishna",
        Email: "ce19d503@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/satyasrikanth.jpg"
    },
    {
        Name: "Shaik Farooq Ahamed",
        Position: "Ph.D Scholar",
        Batch: "July 2019",
        AreasOfResearch: "Reinforced Concrete Design",
        GuideName: "Dr. Bijily Balakrishnan",
        GuideLink: "/dr-bijily-balakrishnan",
        Email: "ce19d506@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/shaik.JPG"
    },
    {
        Name: "Divya Kusuma Tadimeti",
        Position: "Ph.D Scholar",
        Batch: "Jan 2019",
        AreasOfResearch: "Air Pollution",
        GuideName: "Dr. Suresh Jain",
        GuideLink: "/dr-suresh-jain",
        Email: "ce19d006@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/CE19D006_DIVYAKUSUMATADIMETI.jpg"
    },
    {
        Name: "Madhuri Kashyap N R",
        Position: "Ph.D Scholar",
        Batch: "Jan 2019",
        AreasOfResearch: "Traffic flow modeling",
        GuideName: "Dr. A. Gowri",
        GuideLink: "/dr-a-gowri",
        Email: "ce19d003@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/madhuri_CE19D003.jpg"
    },

    {
        Name: "Moola Rajasree",
        Position: "Ph.D Scholar",
        Batch: "Jan 2019",
        AreasOfResearch: "Reservoir Operation",
        GuideName: "Dr. Roshan Srivastav",
        GuideLink: "/dr-roshan-srivastav",
        Email: "ce19d004@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/CE19D004-MOOLA-RAJASREE.jpg"
    },
    {
        Name: "Shaik Mahamad Allabakshi",
        Position: "Ph.D Scholar",
        Batch: "Jan 2019",
        AreasOfResearch: "Waste Water Treatment",
        GuideName: "Dr. Shihabudheen M. Maliyekkal",
        GuideLink: "/dr-shihabudheen-m-maliyekkal",
        Email: "ce19d005@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/CE19D005-SHAIKMAHAMAD-ALLABAKSHI.jpg"
    },
    {
        Name: "Gauri R.Mahajan",
        Position: "Ph.D Scholar",
        Batch: "July 2018",
        AreasOfResearch: "Transportation - Structural Engineering",
        GuideName: "Prof. B. Krishna Prapoorna",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. B Radhika",
        CoGuideLink: "/dr-b-radhika",
        Email: "ce18d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/civil/CE18D501_ MahajanGauriRavikant.jpg"
    },
    {
        Name: "Palagala Venkatesh Yadav",
        Position: "Ph.D Scholar",
        Batch: "July 2018",
        AreasOfResearch: "Structural Engineering",
        GuideName: "Dr. M.Nithyadharan",
        GuideLink: "/dr-nithyadharan",
        Email: "CE18D502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/CE18D502_VenkateshYadav.jpg"
    },
    {
        Name: "Avishreshth",
        Position: "Ph.D Scholar",
        Batch: "Jan 2018",
        AreasOfResearch: "Pavement Materials",
        GuideName: "Prof. B. Krishna Prapoorna",
        GuideLink: "/dr-b-krishna-prapoorna",
        CoGuideName: "Dr. Prasanna Venkatesh Sampath",
        CoGuideLink: "/dr-prasanna-venkatesh",
        Email: "ce18d001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/avish.jpg"
    },
    {
        Name: "Gaddam Sai Jagadeesh",
        Position: "Ph.D Scholar",
        Batch: "Jan 2018",
        AreasOfResearch: "Groundwater Sustainability",
        GuideName: "Dr. Prasanna Venkatesh Sampath",
        GuideLink: "/dr-prasanna-venkatesh",
        Email: "ce18d002@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/jagadeesh.jpg"
    },
    {
        Name: "M. Prasanna Kumar",
        Position: "Ph.D Scholar",
        Batch: "Jan 2018",
        AreasOfResearch: "Non-Destructive Testing",
        GuideName: "Dr. Abhijit Ganguli",
        GuideLink: "/dr-abhijiit-ganguli",
        Email: "ce18d003@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/prasannakumar.jpg"
    },
    {
        Name: "Sudhakar R",
        Position: "M.S (Research) Scholar",
        Batch: "Jan 2018",
        AreasOfResearch: "Construction Management",
        GuideName: "Dr. K. N. Satyanarayana",
        GuideLink: "/dr-k-n-satyanarayana",
        Email: "ce18s001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/sudhakar.jpg"
    },
    {
        Name: "Uthra Devi K.",
        Position: "Ph.D Scholar",
        Batch: "Jan 2018",
        AreasOfResearch: "Nanomaterials for environmental remediation",
        GuideName: "Dr. Shihabudheen M.Maliyekkal",
        GuideLink: "/dr-shihabudheen-m-maliyekkal",
        Email: "ce18d006@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/utharadevi.jpg"
    },
    {
        Name: "Vinay H N",
        Position: "Ph.D Scholar",
        Batch: "Jan 2018",
        AreasOfResearch: "Pavement Materials",
        GuideName: "Prof. Krishna Prapoorna Biligiri",
        GuideLink: "/dr-b-krishna-prapoorna",
        Email: "ce18d005@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/Vinay.jpg"
    }
]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Civil  Engineering" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Civil  Engineering</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       

                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasOfResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank" > {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}

                                            

                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main